import LineItem from './LineItem';
import BundleLineItem from './BundleLineItem';
import { View } from 'foundations-components/components/View';
import { HR } from 'foundations-components/transitional/components/HR';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Testing Note
 * Rendering and readOnly tested in OrderSummary-test.
 * lineItemErrors tested in CheckoutContainer-test as part of validation.
 */
const LineItems = _ref => {
  let {
    currencyCode,
    readOnly,
    lineItemErrors,
    groups,
    selectedItems,
    selectionToggles,
    sessionOpen,
    checkoutFeeAdjustment,
    hasFutureCharges,
    isContractSection
  } = _ref;
  const getLineItem = group => group.type === 'bundle' ? group.parent : group.item.lineItem;
  const getItemIndex = group => {
    var _group$parentIndex;
    return group.type === 'bundle' ? (_group$parentIndex = group.parentIndex) !== null && _group$parentIndex !== void 0 ? _group$parentIndex : group.children[0].index : group.item.index;
  };
  const getIsLastItem = index => {
    return index === groups.length - 1;
  };
  const getIsLastFutureItem = index => {
    return hasFutureCharges && getIsLastItem(index);
  };
  const getIsSelectable = index => {
    const group = groups[index];
    return (group === null || group === void 0 ? void 0 : group.type) === 'item' && selectedItems[group.item.index] === false && sessionOpen;
  };
  const getIsPreviousItemSelectable = index => {
    return getIsSelectable(index - 1);
  };
  const getIsFirstSelectable = index => {
    return getIsSelectable(index) && !getIsPreviousItemSelectable(index);
  };
  const getIsLastSelectable = index => {
    return getIsSelectable(index) && getIsLastItem(index);
  };
  const getIsNextItemNonSelectable = index => {
    return !getIsLastItem(index) && !getIsSelectable(index + 1);
  };
  return /*#__PURE__*/_jsx(List, {
    marginBlockEnd: "0",
    ordered: true,
    children: groups.map((group, i) => /*#__PURE__*/_jsxs(ListItem, {
      children: [/*#__PURE__*/_jsx(View, {
        "data-test-id": `checkout-line-item-${getItemIndex(group)}`,
        padding: "600",
        backgroundColor: getIsSelectable(i) ? 'fill-transitional-tabs-pressed' : 'fill-surface-default',
        borderBlockStartColor: getIsFirstSelectable(i) ? 'border-core-default' : undefined,
        borderBlockStartWidth: getIsFirstSelectable(i) ? '100' : undefined,
        borderBlockStartStyle: getIsFirstSelectable(i) ? 'solid' : undefined,
        paddingBlockEnd: getIsLastSelectable(i) ? '600' : getIsSelectable(i) ? '400' : '600',
        paddingBlockStart: getIsFirstSelectable(i) ? '600' : getIsSelectable(i) ? '0' : '600',
        borderEndEndRadius: getIsLastFutureItem(i) ? 'transitional-container-alt' : '0',
        borderEndStartRadius: getIsLastFutureItem(i) ? 'transitional-container-alt' : '0',
        children: group.type === 'bundle' ? /*#__PURE__*/_jsx(BundleLineItem, {
          currencyCode: currencyCode,
          parent: group.parent,
          bundleChildren: group.children.map(child => child.lineItem),
          isParentInSection: group.parentIndex !== null,
          checkoutFeeAdjustment: checkoutFeeAdjustment,
          hasFutureItemExpired: [group.parentIndex, ...group.children.map(child => child.index)].some(index => {
            var _lineItemErrors$index;
            return index !== null && ((_lineItemErrors$index = lineItemErrors[index]) === null || _lineItemErrors$index === void 0 ? void 0 : _lineItemErrors$index.hasFutureItemExpired);
          })
        }) : /*#__PURE__*/_jsx(LineItem, {
          currencyCode: currencyCode,
          error: lineItemErrors[group.item.index],
          lineItem: group.item.lineItem,
          readOnly: readOnly,
          selected: selectedItems[group.item.index],
          toggleSelected: selectionToggles[group.item.index],
          sessionOpen: sessionOpen,
          checkoutFeeAdjustment: checkoutFeeAdjustment,
          isContractSection: isContractSection
        })
      }), getIsNextItemNonSelectable(i) && /*#__PURE__*/_jsx(HR, {
        inlineSize: "calc(100% - 48px)",
        margin: "0",
        marginInlineStart: "600"
      })]
    }, getLineItem(group).id))
  });
};
export default LineItems;